export enum ResponseStatus {
  // successful responses
  noContent = 204,
  // client error responses
  badRequest = 400,
  forbidden = 403,
  notFound = 404,
  conflict = 409,
  // server error responses
  internalServerError = 500,
}
